/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_steps_invite_team = /** @type {(inputs: {}) => string} */ () => {
	return `Equipo`
};

const en_onboarding_steps_invite_team = /** @type {(inputs: {}) => string} */ () => {
	return `Team`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_steps_invite_team = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_steps_invite_team(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_steps_invite_team", locale)
	if (locale === "es") return es_onboarding_steps_invite_team(inputs)
	return en_onboarding_steps_invite_team(inputs)
};
export { onboarding_steps_invite_team as "onboarding.steps.invite_team" }